import { Injectable } from '@angular/core';

import { QuickFilter } from '../components/filters/filter.interface';
import { UserStateService } from './users/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class FiltersDataService {
  constructor(private userService: UserStateService) {}

  getQuickFilters(filterId: string): QuickFilter[] {
    let filters: QuickFilter[] = [];
    const str = localStorage.getItem(this.key(filterId));

    if (str) {
      try {
        filters = JSON.parse(str);
      } catch {
        filters = [];
      }
    }

    return filters;
  }

  saveQuickFilters(filterId: string, quickFilters: QuickFilter[]) {
    const str = JSON.stringify(quickFilters);
    localStorage.setItem(this.key(filterId), str);
  }

  saveQuickFilter(filterId: string, quickFilter: QuickFilter) {
    let quickFiltersList = this.getQuickFilters(filterId);
    const index = quickFiltersList.findIndex((x) => {
      return x.name == quickFilter.name;
    });

    if (quickFilter.default) {
      for (const x of quickFiltersList) {
        x.default = false;
      }

      if (index >= 0) {
        quickFiltersList.splice(index, 1);
      }

      quickFiltersList = [quickFilter, ...quickFiltersList];
    } else {
      if (index >= 0) {
        quickFiltersList[index] = quickFilter;
      } else {
        quickFiltersList.push(quickFilter);
      }
    }

    this.saveQuickFilters(filterId, quickFiltersList);
  }

  deleteQuickFilter(filterId: string, name: string) {
    const quickFilters = this.getQuickFilters(filterId);
    const index = quickFilters.findIndex((x) => {
      return x.name == name;
    });

    if (index >= 0) {
      quickFilters.splice(index, 1);
      this.saveQuickFilters(filterId, quickFilters);
    }
  }

  resetQuickFilters(filterId: string) {
    localStorage.removeItem(this.key(filterId));
  }

  private key(filterId: string): string {
    return `filter_${this.userService.user?.id}_${filterId}`;
  }
}
